module.exports = __webpack_public_path__ + "static/media/sm00.aa5c14f3.png";